import React from 'react';
import styled from 'styled-components';

import Work from './Work';

const WorkGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));
  grid-gap: 45px;

  @media screen and (max-width: 1200px) {
    grid-gap: 25px;
  }

  @media screen and (max-width: 800px) {
    grid-template-columns: 100%;
    grid-gap: 25px 0;
  }
`;

export default props => (
  <WorkGrid>
    {props.data.map(work => (
      <Work
        key={work.title}
        name={work.title}
        description={work.description}
        tags={work.tags}
        images={work.images}
        url={work.url}
      />
    ))}
  </WorkGrid>
);



// WEBPACK FOOTER //
// ./src/components/Work/WorkGrid.js